module.exports = __webpack_public_path__ + "static/media/sleepyDragonzFrame5.a21fbd01.png";